import styled, { RuleSet } from 'styled-components'
import { Typography } from 'src/components/Typography'
import { Noto_body1_r16, Noto_body3_b12, Noto_body3_r12 } from 'src/styles/font/NotoSansKrFonts'
import { Link } from 'react-router-dom'
import usePcodeMatch from 'src/hooks/usePcodeMatch.hook'
import React from 'react'

const BillLetterFooter = () => {
  const { bill_letter_03 } = usePcodeMatch()

  const billLetterCancelPageUrl = bill_letter_03
    ? 'https://www.couponwallet.co.kr/cancel'
    : 'sendEventToApp:onClickedOutPage=https://www.couponwallet.co.kr/cancel'

  const billLetterHomePageUrl = bill_letter_03
    ? 'https://www.couponwallet.co.kr'
    : 'sendEventToApp:onClickedOutPage=https://www.couponwallet.co.kr'

  return (
    <BillLetterFooterContainer>
      <BillLetterFooterPrimary $fontStyle={Noto_body1_r16}>유의사항</BillLetterFooterPrimary>
      <BillLetterFooterUl>
        <BillLetterFooterLi $fontStyle={Noto_body3_r12}>
          본 서비스는 가입 즉시 서비스가 개시되는 상품이므로 청약철회 및 환불이 불가능합니다.
          (전자상거래 등에서의 소비자보호에 관한 법률 제17조 2항 5호에 따라 디지털 콘텐츠의 제공이
          개시된 경우 청약철회를 제공하지 않습니다.)
        </BillLetterFooterLi>
        <BillLetterFooterLi $fontStyle={Noto_body3_b12}>
          서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.
        </BillLetterFooterLi>
        <BillLetterFooterLi $fontStyle={Noto_body3_r12}>
          본 서비스는 이용요금{' '}
          <Typography $color={'#F00'} $fontStyle={Noto_body3_b12}>
            매월 5,500원(VAT포함)
          </Typography>
          이 SKT 요금에 포함되어 청구됩니다.
        </BillLetterFooterLi>
        <BillLetterFooterLi $fontStyle={Noto_body3_r12}>
          서비스 해지방법 :{' '}
          <Typography $color={'#F00'} $fontStyle={Noto_body3_b12}>
            1855-4531{' '}
          </Typography>
          또는{' '}
          <BillLetterFooterLinkStyle to={billLetterCancelPageUrl} target={'_blank'}>
            https://www.couponwallet.co.kr/cancel
          </BillLetterFooterLinkStyle>
        </BillLetterFooterLi>
        <BillLetterFooterLi $fontStyle={Noto_body3_r12}>
          휴대폰도난결제 보상 보험은 가입 다음날 0시부터 제공되며, 자기부담금 20만원(1회 사고당)이
          발생합니다. 해당 보험은 1인 1사고당 보험한도액 100만원 내 보상하며, 증권상 최대 보상한도액
          초과 시 보험금이 지급되지 않을 수 있습니다.
        </BillLetterFooterLi>
        <BillLetterFooterLi $fontStyle={Noto_body3_r12}>
          서비스 내 한정 수량으로 판매되는 핫딜 쿠폰은 회차당 1인 1개, 월 최대 10개까지 구매
          가능하며, 판매 정책은 추후 변경될 수 있습니다.
        </BillLetterFooterLi>
        <BillLetterFooterLi $fontStyle={Noto_body3_r12}>
          서비스 홈페이지 :{' '}
          <BillLetterFooterLinkStyle to={billLetterHomePageUrl} target={'_blank'}>
            https://www.couponwallet.co.kr
          </BillLetterFooterLinkStyle>
        </BillLetterFooterLi>
        <BillLetterFooterLi $fontStyle={Noto_body3_r12}>
          사업자등록번호 : 382-86-01230
        </BillLetterFooterLi>
        <BillLetterFooterLi $fontStyle={Noto_body3_r12}>
          통신판매업신고 : 제2020-서울영등포-1315호
        </BillLetterFooterLi>
      </BillLetterFooterUl>
    </BillLetterFooterContainer>
  )
}
export default BillLetterFooter

const BillLetterFooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  padding: 55px 20px 115px 20px;
  gap: 10px;
`
const BillLetterFooterPrimary = styled(Typography)`
  margin-bottom: 10px;
`

const BillLetterFooterLinkStyle = styled(Link)`
  ${Noto_body3_b12};
  text-decoration: underline;
`
const BillLetterFooterUl = styled.ul`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  list-style: disc;
  gap: 2px;
`
const BillLetterFooterLi = styled.li<{ $fontStyle?: RuleSet<Object>; $color?: string }>`
  list-style: disc;
  white-space: break-spaces;
  ${(props) => props.$fontStyle};
  color: ${(props) => props.$color};
`
